import type { ReactNode } from 'react';
import { OverlayArrow, TooltipTrigger } from 'react-aria-components';
import TooltipArrow from '@/assets/icons/TooltipArrow.svg';
import * as Styled from './Tooltip.styled';

interface TooltipProps {
  children: ReactNode;
  placement?: 'start' | 'top' | 'bottom' | 'end';
  tip: string;
}

export const Tooltip = ({ children, placement, tip }: TooltipProps) => (
  <TooltipTrigger>
    {children}
    <Styled.Overlay placement={placement}>
      <OverlayArrow>
        <TooltipArrow />
      </OverlayArrow>
      {tip}
    </Styled.Overlay>
  </TooltipTrigger>
);
